import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';

const styles = css`
display: flex;
flex-direction: column;
gap: 30px;
  .page {
    padding-left: 20px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    .title {
       font-size: 1.5em;
    }
    .about {
      
    }
  }

`;

const Account = styled(({ className }) => {

  return (
    <div className={className}>
      <div className='page'>
        <div className='title'>
          <Link to='profile'>{'Profile'}</Link>
        </div>
        <div className = 'about'>
            Change personal information such as your avatar, displayed name, birthday, address, and phone number
        </div>
      </div>
      <div className='page'>
        <div className='title'>
          <Link to='settings'>{'Settings'}</Link>
        </div>
        <div className = 'about'>
            Change settings such as notifications, profile visibility, default list and group settings
        </div>
      </div>
    </div>
  )
})`${styles}`

export default Account;